import { createApp } from 'vue'
import { Modal } from 'bootstrap'

window.pawine = window.pawine || {}

const app = createApp({
  data() {
    return {
      isLoading: false,
      routes: window.pawine.routes || {},
      episodes: [],
      totalEpisodes: 0,
      selectedEpisode: null,
      pagination: {
        offset: 0,
        limit: 9,
      },
    }
  },
  computed: {
    currentPage() {
      return Math.ceil(this.pagination.offset / this.pagination.limit) + 1;
    },
    totalPages() {
      return Math.ceil(this.totalEpisodes / this.pagination.limit)
    }
  },
  mounted() {
    // We create our own backdrop so that it's behind the modal.
    this.modal = new Modal(this.$refs.episodeModal, {
      backdrop: false,
    })

    this.loadEpisodes()
  },
  methods: {
    async loadEpisodes() {
      this.isLoading = true

      const resp = await axios.get(window.pawine.routes.loadEpisodes, {
        params: {
          offset: this.pagination.offset,
          search: this.search,
        }
      })

      this.episodes = resp.data.episodes
      this.totalEpisodes = resp.data.totalEpisodes

      this.isLoading = false
    },
    scrollToEpisodes() {
      let 
        mainMarginTopOffset = 88,
        headerHeightOffset = 88,
        extaSpacing = 10,
        offsetTop = document.querySelector('#episodes').offsetTop

      // Space for the top margin and header
      if (window.outerWidth >= 992 && window.outerWidth < 1200) {
        mainMarginTopOffset = 121
        headerHeightOffset = 121

      } else if (window.outerWidth >= 1200 && window.outerWidth < 1400) {
        mainMarginTopOffset = 121
        headerHeightOffset = 121

      } else if (window.outerWidth >= 1400 && window.outerWidth < 1620) {
        mainMarginTopOffset = 167
        headerHeightOffset = 167

      } else if (window.outerWidth >= 1620) {
        mainMarginTopOffset = 323
        headerHeightOffset = 203
      }

      offsetTop = (offsetTop + mainMarginTopOffset - headerHeightOffset - extaSpacing)

      scroll({
        top: offsetTop,
        behavior: 'smooth',
      })
    },
    openEpisode(episode) {
      this.selectedEpisode = episode

      this.modal.show()

      this.$refs.backdrop.classList.add('show')
      this.$refs.backdrop.classList.remove('pe-none')
    },
    closeEpisode() {
      this.modal.hide()

      this.$refs.backdrop.classList.remove('show')
      this.$refs.backdrop.classList.add('pe-none')

      this.selectedEpisode = null
    },
    async loadPreviousPage() {
      if (this.pagination.offset > 0) {
        this.pagination.offset -= (this.pagination.limit)
        
        await this.loadEpisodes()
        this.scrollToEpisodes()
      }
    },
    async loadNextPage() {
      this.pagination.offset += (this.pagination.limit)
      
      await this.loadEpisodes()
      this.scrollToEpisodes()
    },
  }
})

app.mount('#podcast-episodes')
